<!--
 * @Author: M.D.
 * @Date: 2019-12-09 14:17:35
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="k-footer">
    <el-row>
      <el-col :span="20" :offset="2">
        <div class="container">
          <div class="section f">
            <div class="title">客户服务</div>
            <div class="content">
              <div class="left" @click="myPoint">
                <img src="@/assets/image/footer_jf.png" alt="" />
                <div class="t">积分好兑</div>
              </div>
              <div class="right" @click="question">
                <img src="@/assets/image/footer_wt.png" alt="" />
                <div class="t">常见问题</div>
              </div>
            </div>
          </div>
          <div class="section s">
            <div class="title">千街万巷公众号</div>
            <div class="content">
              <div class="kf-img-wrapper">
                <img src="@/assets/image/footer_qjwx.png" alt="" />
              </div>
              <div class="text">
                <p>扫描二维码</p>
                <p>关注千街万巷公众号</p>
                <p>微信公众号</p>
              </div>
            </div>
          </div>

          <div class="section s">
            <div class="title">成都千街万巷商务服务有限公司 官网</div>
            <div class="content">
              <div class="kf-img-wrapper" @click="officalWebsite">
                <img src="@/assets/image/footer_o.png" alt="" />
              </div>
              <div class="text">
                <p>点击图片</p>
                <p>访问成都千街万巷商务服务有限公司</p>
                <p>官方网站</p>
              </div>
              <div class="content">
                <div class="kf-img-wrapper">
                  <img src="@/assets/image/esp_qr.jpeg" alt="" />
                </div>
                <div class="text">
                  <p>扫描二维码</p>
                  <p>关注千街云服务</p>
                  <p>微信公众号</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { usrStatus } from '@/util/mixin'
export default {
  mixins: [usrStatus],
  props: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    officalWebsite() {
      console.log('3214')
      window.open(`https://www.chinaqjwx.cn/`, '_blank')
    },
    myPoint() {
      if (!this.isLogin) {
        this.$emit('openLoginDialog')
        return
      }
      this.$router.push({
        name: 'mypoint',
      })
    },
    question() {
      this.$router.push({
        name: 'qa',
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.k-footer {
  height: 258px;

  .container {
    display: flex;

    .section {
      flex: 1 1 33.33%;

      .kf-img-wrapper {
        display: block;
        width: 90px;
        height: 90px;
      }

      &>div {
        width: 100%;
      }

      .title {
        margin: 36px auto;
        text-align: center;
        color: #333333;
      }

      .content {
        center();
      }

      &.f {
        .left, .right {
          box-sizing: border-box;
          border: 1px solid #cccccc;
          text-align: center;
          width: 90px;
          height: 90px;
          padding: 16px 0 22px;
          margin: 0 10px;
        }

        .content {
          img {
            display: inline-block;
            height: 30px;
            width: 30px;
          }

          .t {
            padding-top: 8px;
            width: 100%;
            color: #555555;
            font-size: 14px;
          }
        }
      }

      &.s {
        .content {
          .kf-img-wrapper {
            width: 90px;
            height: 90px;

            img {
              display: inline-block;
              width: 100%;
              height: 100%;
            }
          }

          .text {
            margin-left: 20px;
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }
  }
}
</style>
